// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__pFb3C","modal":"styles_modal__BAJ71","closeIcon":"styles_closeIcon__7DMpR","iframe":"styles_iframe__8s4qK"};